import { jsx as a, jsxs as o } from "react/jsx-runtime";
const t = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53m-1.73 2a1 1 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02zM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1" })
  }
), n = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: [
      /* @__PURE__ */ a("path", { d: "M10 14c.345 0 .68.044 1 .126v1.228a4.012 4.012 0 0 0-.465.646H9v-1.874A4.01 4.01 0 0 1 10 14" }),
      /* @__PURE__ */ a("path", { d: "M11 15.354V16h-.465c.134-.23.29-.447.465-.646M13 16h2v-4h-2v3.354z" }),
      /* @__PURE__ */ a(
        "path",
        {
          fillRule: "evenodd",
          d: "M8 18a2 2 0 0 1 2-2H9v-1.874a4.002 4.002 0 1 0 3 7.339 4 4 0 1 0 1-7.339v1.228c.175.199.331.415.465.646H14a2 2 0 1 1-2 2 2 2 0 0 1-4 0m1-3.874a4.01 4.01 0 0 1 2 0V12H9z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a("path", { d: "M13 8h2v4h-2V8.646z" }),
      /* @__PURE__ */ a(
        "path",
        {
          fillRule: "evenodd",
          d: "M9 9.874V12h2V9.874a4.007 4.007 0 0 1-2 0M14 10c.345 0 .68-.044 1-.126V8H13.465c-.134.23-.29.447-.465.646v1.228c.32.082.655.126 1 .126",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a("path", { d: "M11 8.646V8h-.465c.134.23.29.447.465.646" }),
      /* @__PURE__ */ a("path", { d: "M10 8a2 2 0 1 1 2-2 2 2 0 1 1 2 2h1v1.874a4.002 4.002 0 1 0-3-7.339 4 4 0 1 0-3 7.339V8z" }),
      /* @__PURE__ */ a("path", { d: "M10 10c.345 0 .68-.044 1-.126V8.646A4.014 4.014 0 0 1 10.535 8H9v1.874c.32.082.655.126 1 .126" })
    ]
  }
), c = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1.002 1.002 0 1 0-1.41-1.42M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20" })
  }
), r = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M18.71 7.21a1.001 1.001 0 0 0-1.42 0l-7.45 7.46-3.13-3.14a1.024 1.024 0 0 0-1.445.025A1.022 1.022 0 0 0 5.29 13l3.84 3.84a1.001 1.001 0 0 0 1.42 0l8.16-8.16a1 1 0 0 0 0-1.47" })
  }
), v = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M17 11H9.41l3.3-3.29a1.004 1.004 0 1 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l5 5a1.002 1.002 0 0 0 1.639-.325 1.002 1.002 0 0 0-.219-1.095L9.41 13H17a1 1 0 0 0 0-2" })
  }
), w = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M17.92 11.62a1.001 1.001 0 0 0-.21-.33l-5-5a1.003 1.003 0 1 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l5-5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
  }
), i = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M10 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4.5 4.06a1 1 0 0 0-1.37.36 1.3 1.3 0 0 1-2.26 0 1 1 0 0 0-1.37-.36 1 1 0 0 0-.37 1.36 3.31 3.31 0 0 0 5.74 0 1 1 0 0 0-.37-1.36M15 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3-7a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18A8 8 0 0 1 9 4.57c-.01.143-.01.287 0 .43a3 3 0 0 0 3 3 1 1 0 1 0 0-2 1 1 0 1 1 0-2 8 8 0 0 1 0 16" })
  }
), e = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M3 8h18a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2m18 8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
  }
), s = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M14 8h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2m0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2M9 8h1a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m12 8h-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-8 0h-2v-4h2zm5 0h-3v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H6V4h12z" })
  }
), g = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-12h-1V2a1 1 0 0 0-2 0v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16zm0-11H4V6a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V5h8v1a1 1 0 0 0 2 0V5h1a1 1 0 0 1 1 1zM7 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" })
  }
), d = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.443 9.443 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.18 12.18 0 0 1-2.66-2 12.18 12.18 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10.32 10.32 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2.741-1.778 3 3 0 0 0 .259-1.232v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.723.962 1.05 1.05 0 0 1-.437.038A17 17 0 0 1 4.07 5.22a1.09 1.09 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79c.04.273.09.543.15.81.116.527.27 1.045.46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7 1 1 0 0 0 .76 0 1.002 1.002 0 0 0 .57-.52l.62-1.4c.517.185 1.045.338 1.58.46.267.06.537.11.81.15a1 1 0 0 1 .79 1z" })
  }
), m = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M21.12 16.88a3 3 0 0 0-3.4-.58l-1.15-1.14a23.999 23.999 0 0 0 5.21-8.86 3.19 3.19 0 0 0-4.08-4.08 24 24 0 0 0-8.86 5.21L7.7 6.28a3 3 0 1 0-4.82.84A3 3 0 0 0 5 8a3 3 0 0 0 1.28-.3l1.15 1.14a24 24 0 0 0-5.21 8.86A3.24 3.24 0 0 0 3 21a3.17 3.17 0 0 0 2.22 1 3.74 3.74 0 0 0 1.08-.17 24 24 0 0 0 8.86-5.21l1.14 1.15a3 3 0 1 0 4.82-.84zM5.71 5.7a1 1 0 1 1-1.42-1.41A1 1 0 0 1 5.71 5.7m12.6-1.57a1.6 1.6 0 0 1 .47-.08 1.16 1.16 0 0 1 .83.34 1.23 1.23 0 0 1 .26 1.3 22.089 22.089 0 0 1-2.13 4.64l-4.07-4.07a22.091 22.091 0 0 1 4.64-2.13M5.69 19.87a1.2 1.2 0 0 1-1.56-1.56 22.089 22.089 0 0 1 2.13-4.64l4.07 4.07a22.093 22.093 0 0 1-4.64 2.13M12 16.59 7.41 12a21.3 21.3 0 0 1 1.43-1.74l4.91 4.91c-.558.504-1.142.978-1.75 1.42m3.15-2.84-4.9-4.91A21.297 21.297 0 0 1 12 7.41l4.6 4.6c-.449.605-.93 1.186-1.44 1.74zm4.55 6a1.001 1.001 0 0 1-1.42-1.41 1 1 0 0 1 1.41 0 1 1 0 0 1 .02 1.37z" })
  }
), p = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 9a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m7-7H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zM12 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" })
  }
), x = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1.002 1.002 0 0 0 1.42 0L17 10.59a1.002 1.002 0 0 0 0-1.42" })
  }
), I = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m11.29 12 3.54-3.54a1 1 0 1 0-1.42-1.41l-4.24 4.24a1.001 1.001 0 0 0 0 1.42L13.41 17a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41z" })
  }
), M = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m14.83 11.29-4.24-4.24a1 1 0 1 0-1.42 1.41L12.71 12l-3.54 3.54a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.24-4.24a1.002 1.002 0 0 0 0-1.42" })
  }
), C = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m13.41 12 6.3-6.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l6.29-6.3 6.29 6.3a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095z" })
  }
), u = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M7 15h3a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2M19 5H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6h16zm0-8H4V8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" })
  }
), A = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M5 18h4.24a.999.999 0 0 0 .71-.29l6.92-6.93L19.71 8a1.001 1.001 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1.001 1.001 0 0 0-.29.71V17a1 1 0 0 0 1 1m9.76-13.59 2.83 2.83-1.42 1.42-2.83-2.83zM6 13.17l5.93-5.93 2.83 2.83L8.83 16H6zM21 20H3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2" })
  }
), f = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M18 10.82a1 1 0 0 0-1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1 1 0 0 0-1-1m3.92-8.2a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.59L8.29 14.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219L20 5.41V9a1 1 0 0 0 2 0V3a1.001 1.001 0 0 0-.08-.38" })
  }
), V = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.18 0-6.17-2.29-7.9-6C5.83 8.29 8.82 6 12 6c3.18 0 6.17 2.29 7.9 6-1.73 3.71-4.72 6-7.9 6m0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4" })
  }
), S = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M15.12 5.32H17V2.14A26.113 26.113 0 0 0 14.26 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.61v3.56h3.07V22h3.68v-9.12h3.06l.46-3.56h-3.52V7.05c0-1.05.28-1.73 1.76-1.73" })
  }
), B = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M11.29 15.29a1.573 1.573 0 0 0-.12.15.762.762 0 0 0-.09.18.643.643 0 0 0-.06.18 1.362 1.362 0 0 0 0 .2.84.84 0 0 0 .08.38.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54A1 1 0 0 0 13 16a1 1 0 0 0-1.71-.71M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20m0-13a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A1 1 0 0 1 12 9a1 1 0 1 1 0 2 1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-.18A3 3 0 0 0 12 7" })
  }
), z = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currenColor",
        d: "M19 2a1 1 0 0 0-1 1v5.46l-1 .67V3a1 1 0 0 0-2 0v6.13l-1-.67V3a1 1 0 0 0-2 0v6a1 1 0 0 0 .45.83L15 11.54V21a1 1 0 0 0 2 0v-9.46l2.55-1.71A1 1 0 0 0 20 9V3a1 1 0 0 0-1-1M9 2a5 5 0 0 0-5 5v6a1 1 0 0 0 1 1h3v7a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1M8 12H6V7a3 3 0 0 1 2-2.83z"
      }
    )
  }
), H = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4v-4h4zm0-6H4v-4h4zm0-6H4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4z" })
  }
), L = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1m.92 8.62a.758.758 0 0 0-.09-.18l-.12-.15a.999.999 0 0 0-1.09-.21 1.15 1.15 0 0 0-.33.21A1 1 0 0 0 11 16c.002.13.029.26.08.38a.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54c.051-.12.078-.25.08-.38a1.362 1.362 0 0 0 0-.2.639.639 0 0 0-.08-.18M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20" })
  }
), P = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M17.34 5.46a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m4.6 2.42a7.588 7.588 0 0 0-.46-2.43 4.94 4.94 0 0 0-1.16-1.77 4.7 4.7 0 0 0-1.77-1.15 7.3 7.3 0 0 0-2.43-.47C15.06 2 14.72 2 12 2s-3.06 0-4.12.06a7.3 7.3 0 0 0-2.43.47 4.78 4.78 0 0 0-1.77 1.15 4.7 4.7 0 0 0-1.15 1.77 7.3 7.3 0 0 0-.47 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12a7.3 7.3 0 0 0 .47 2.43 4.7 4.7 0 0 0 1.15 1.77 4.78 4.78 0 0 0 1.77 1.15 7.3 7.3 0 0 0 2.43.47C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.3 7.3 0 0 0 2.43-.47 4.7 4.7 0 0 0 1.77-1.15 4.85 4.85 0 0 0 1.16-1.77c.285-.78.44-1.6.46-2.43 0-1.06.06-1.4.06-4.12s0-3.06-.06-4.12M20.14 16a5.61 5.61 0 0 1-.34 1.86 3.06 3.06 0 0 1-.75 1.15c-.324.33-.717.586-1.15.75a5.61 5.61 0 0 1-1.86.34c-1 .05-1.37.06-4 .06s-3 0-4-.06a5.73 5.73 0 0 1-1.94-.3 3.27 3.27 0 0 1-1.1-.75 3 3 0 0 1-.74-1.15 5.54 5.54 0 0 1-.4-1.9c0-1-.06-1.37-.06-4s0-3 .06-4a5.54 5.54 0 0 1 .35-1.9A3 3 0 0 1 5 5a3.14 3.14 0 0 1 1.1-.8A5.73 5.73 0 0 1 8 3.86c1 0 1.37-.06 4-.06s3 0 4 .06a5.61 5.61 0 0 1 1.86.34 3.06 3.06 0 0 1 1.19.8c.328.307.584.683.75 1.1.222.609.337 1.252.34 1.9.05 1 .06 1.37.06 4s-.01 3-.06 4M12 6.87A5.13 5.13 0 1 0 17.14 12 5.12 5.12 0 0 0 12 6.87m0 8.46a3.33 3.33 0 1 1 0-6.66 3.33 3.33 0 0 1 0 6.66" })
  }
), R = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M17.811 5.23A7.45 7.45 0 0 0 12.505 3c-1.99 0-3.9.802-5.307 2.23A7.67 7.67 0 0 0 5 10.614c0 2.019.79 3.955 2.198 5.383l4.661 4.738a.884.884 0 0 0 .628.265.874.874 0 0 0 .628-.265l4.696-4.783A7.638 7.638 0 0 0 20 10.592c0-2.012-.787-3.94-2.189-5.362m-1.265 9.44-4.041 4.118-4.042-4.119A5.823 5.823 0 0 1 6.9 11.701a5.874 5.874 0 0 1 .326-3.348 5.78 5.78 0 0 1 2.104-2.6 5.655 5.655 0 0 1 3.174-.977c1.13 0 2.234.34 3.173.977a5.779 5.779 0 0 1 2.105 2.6 5.874 5.874 0 0 1 .326 3.348 5.823 5.823 0 0 1-1.563 2.968M9.851 7.858a3.905 3.905 0 0 0-1.115 2.737c0 1.025.401 2.01 1.115 2.736.53.54 1.206.907 1.942 1.058a3.76 3.76 0 0 0 2.195-.209 3.823 3.823 0 0 0 1.713-1.407c.422-.63.652-1.372.66-2.134a3.853 3.853 0 0 0-.284-1.482 3.808 3.808 0 0 0-.83-1.254 3.801 3.801 0 0 0-1.23-.853 3.756 3.756 0 0 0-4.166.808m4.148 4.2a2.038 2.038 0 0 1-2.604.277 2.088 2.088 0 0 1-.833-1.13 2.12 2.12 0 0 1 .063-1.41 2.08 2.08 0 0 1 .932-1.047c.42-.23.907-.303 1.376-.209.468.095.89.351 1.192.726.303.375.468.845.467 1.33a2.104 2.104 0 0 1-.637 1.462z" })
  }
), k = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m12.59 13-2.3 2.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1.003 1.003 0 1 0-1.42 1.42l2.3 2.29H3a1 1 0 0 0 0 2zM12 2a10 10 0 0 0-9 5.55 1.006 1.006 0 1 0 1.8.9A8 8 0 1 1 12 20a7.929 7.929 0 0 1-7.16-4.45 1.006 1.006 0 0 0-1.8.9A10 10 0 1 0 12 2" })
  }
), U = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m21.32 5.05-6-2h-.07a.701.701 0 0 0-.14 0h-.43L9 5 3.32 3.05a1 1 0 0 0-.9.14A1 1 0 0 0 2 4v14a1 1 0 0 0 .68.95l6 2c.201.066.419.066.62 0l5.7-1.9L20.68 21c.106.015.214.015.32 0a.94.94 0 0 0 .58-.19A1.002 1.002 0 0 0 22 20V6a1 1 0 0 0-.68-.95M8 18.61l-4-1.33V5.39l4 1.33zm6-1.33-4 1.33V6.72l4-1.33zm6 1.33-4-1.33V5.39l4 1.33z" })
  }
), b = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
  }
), E = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M10.94 6.08A6.93 6.93 0 0 1 12 6c3.18 0 6.17 2.29 7.91 6a15.213 15.213 0 0 1-.9 1.64 1 1 0 0 0 .05 1.152 1 1 0 0 0 1.65-.102 15.75 15.75 0 0 0 1.21-2.3.999.999 0 0 0 0-.79C19.9 6.91 16.1 4 12 4a7.77 7.77 0 0 0-1.4.12 1.015 1.015 0 0 0 .34 2zM3.71 2.29a1.004 1.004 0 1 0-1.42 1.42l3.1 3.09a14.62 14.62 0 0 0-3.31 4.8 1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20a9.26 9.26 0 0 0 5.05-1.54l3.24 3.25a.998.998 0 0 0 1.42 0 .997.997 0 0 0 .219-1.095.998.998 0 0 0-.22-.325zm6.36 9.19 2.45 2.45a2 2 0 0 1-2.45-2.45M12 18c-3.18 0-6.17-2.29-7.9-6a12.09 12.09 0 0 1 2.7-3.79L8.57 10A4 4 0 0 0 14 15.43L15.59 17A7.239 7.239 0 0 1 12 18" })
  }
), F = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.443 9.443 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.18 12.18 0 0 1-2.66-2 12.18 12.18 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10.32 10.32 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2.741-1.778 3 3 0 0 0 .259-1.232v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.723.962 1.05 1.05 0 0 1-.437.038A17 17 0 0 1 4.07 5.22a1.09 1.09 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79c.04.273.09.543.15.81.116.527.27 1.045.46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7 1 1 0 0 0 .76 0 1.002 1.002 0 0 0 .57-.52l.62-1.4c.517.185 1.045.338 1.58.46.267.06.537.11.81.15a1 1 0 0 1 .79 1z"
      }
    )
  }
), T = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14c.165-.002.328-.019.49-.05l.3-.07H19.91l.37-.14.13-.07c.1-.06.21-.11.31-.18a3.78 3.78 0 0 0 .38-.32l.07-.09c.098-.1.188-.206.27-.32l.09-.13c.07-.111.13-.228.18-.35.027-.048.05-.098.07-.15.05-.12.08-.25.12-.38v-.15c.057-.195.09-.397.1-.6V5a3 3 0 0 0-3-3M5 20a1 1 0 0 1-1-1v-4.31l3.29-3.3a1 1 0 0 1 1.42 0l8.6 8.61zm15-1a1 1 0 0 1-.07.36c-.023.049-.05.096-.08.14a.948.948 0 0 1-.09.12l-5.35-5.35.88-.88a1.002 1.002 0 0 1 1.42 0l3.29 3.3zm0-5.14L18.12 12a3.08 3.08 0 0 0-4.24 0l-.88.88L10.12 10a3.08 3.08 0 0 0-4.24 0L4 11.86V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" })
  }
), y = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "m20.71 16.1-1.64-1.64a.94.94 0 0 1-.22-1.07 5.78 5.78 0 0 0 .54-2.39.356.356 0 0 0 0-.1 5.74 5.74 0 0 0-1.06-3.34 14.17 14.17 0 0 0-5.17-4.42 7 7 0 0 0-8 1.31l-.67.67a7 7 0 0 0-1.31 8.05l.1.17a3 3 0 0 0-.84 2.06A3 3 0 0 0 7 17.94c.18.14.34.29.52.42.379.263.788.478 1.22.64h.09c.18.07.37.13.57.19h.15c.311.08.63.13.95.15h.62c.21 0 .41 0 .62-.06h.17c.492-.085.97-.236 1.42-.45a1 1 0 0 1 1.07.21l1.46 1.46a3.4 3.4 0 0 0 2.39 1 2.85 2.85 0 0 0 2-.85l.38-.38a3 3 0 0 0 .08-4.17m-15.3.32a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3.1.14-.26-.2a2.94 2.94 0 0 0 .16-.94 3 3 0 0 0-3-3h-.38l-.09-.16a5 5 0 0 1 .93-5.75l.67-.67A5 5 0 0 1 12.28 5a12 12 0 0 1 4.26 3.57zm10.78 2.37-.37.38c-.42.42-1.07.34-1.61-.2l-1.46-1.45a3 3 0 0 0-3.34-.61c-.315.154-.653.259-1 .31a2.836 2.836 0 0 1-.58.05H10.49l6.87-6.87a3.8 3.8 0 0 1-.34 2 3 3 0 0 0 .61 3.34l1.64 1.65a1 1 0 0 1 .02 1.4" })
  }
), j = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2" })
  }
), q = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M20 8.18V3a1 1 0 0 0-2 0v5.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-7.18a3 3 0 0 0 0-5.64M19 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-6 2.18V3a1 1 0 0 0-2 0v11.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 0-5.64M12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2M6 6.18V3a1 1 0 0 0-2 0v3.18a3 3 0 0 0 0 5.64V21a1 1 0 1 0 2 0v-9.18a3 3 0 0 0 0-5.64M5 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
  }
), D = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M22 2H2a1 1 0 0 0-1 1v4a3 3 0 0 0 2 2.82V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9.82A3 3 0 0 0 23 7V3a1 1 0 0 0-1-1m-7 2h2v3a1 1 0 0 1-2 0zm-4 0h2v3a1 1 0 0 1-2 0zM7 4h2v3a1 1 0 0 1-2 0zM4 8a1 1 0 0 1-1-1V4h2v3a1 1 0 0 1-1 1m10 12h-4v-4a2 2 0 0 1 4 0zm5 0h-3v-4a4 4 0 1 0-8 0v4H5V9.82a3.17 3.17 0 0 0 1-.6 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 4 0c.293.26.632.464 1 .6zm2-13a1 1 0 0 1-2 0V4h2z" })
  }
), G = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.45 1.07L12 18.76l5.1 2.68c.14.08.299.12.46.12a1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67m-6.15 4a1.001 1.001 0 0 0-.29.89l.72 4.19-3.76-2a1 1 0 0 0-.94 0l-3.76 2 .72-4.19a1 1 0 0 0-.29-.89l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61z" })
  }
), N = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ...h,
    children: /* @__PURE__ */ a(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.634 4.706a1 1 0 1 1 1.732-1l.028.048a9 9 0 0 1 11.4 3.746 1 1 0 0 1-.366 1.366l-6.062 3.5 4 6.928c.015.026.029.053.041.08a2.795 2.795 0 0 1 1.05-.271c1.013-.046 2.01.428 2.725 1.397.435.588.829.63 1.082.587.343-.058.607-.3.68-.45l1.616.795c-.339.687-1.104 1.28-1.996 1.43-.982.166-2.03-.21-2.83-1.292-.393-.533-.838-.685-1.195-.67-.372.018-.757.22-1.021.609-.413.608-1.24 1.22-2.163 1.356-1.012.15-2.146-.174-3.055-1.25-.863-1.021-2.166-.855-2.79-.09-.359.647-1.094 1.193-1.946 1.337-.982.166-2.03-.21-2.83-1.292-.393-.533-.838-.685-1.195-.67-.378.018-.77.227-1.035.629L1 20.54c.56-.852 1.465-1.394 2.458-1.438 1.012-.046 2.008.428 2.724 1.397.435.588.829.63 1.082.587.343-.058.607-.3.68-.45l.088-.143c1.276-1.7 3.99-1.998 5.643-.04.503.596 1.016.69 1.416.63.396-.058.687-.264.818-.411l.033-.049a.996.996 0 0 1-.308-.33l-4-6.928-6.062 3.5a1 1 0 0 1-1.366-.366A9 9 0 0 1 6.662 4.754zM8.5 5.938a7 7 0 0 0-3 8.66l12-6.928a7 7 0 0 0-9-1.732",
        clipRule: "evenodd"
      }
    )
  }
), W = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 3A10 10 0 0 0 2 13v7a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H4a8 8 0 0 1 16 0h-2a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h3a1 1 0 0 0 1-1v-7A10 10 0 0 0 12 3M6 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4v-4zm14 4h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2z" })
  }
), J = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M9 10a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m12 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1 1 1 0 0 1 0-2m-1-1.82a3 3 0 0 0 0 5.64V17H10a1 1 0 1 0-2 0H4v-2.18a3 3 0 0 0 0-5.64V7h4a1 1 0 0 0 2 0h10z" })
  }
), K = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M11 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-14a1 1 0 0 0-1 1v4.42l-2.1 1.21a1 1 0 0 0 .5 1.87 1 1 0 0 0 .5-.13l2.6-1.5.09-.09.16-.13a.863.863 0 0 0 .1-.16.891.891 0 0 0 .08-.17.65.65 0 0 0 .05-.2L12 12V7a1 1 0 0 0-1-1" })
  }
), O = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M22 5.8a8.49 8.49 0 0 1-2.36.64 4.13 4.13 0 0 0 1.81-2.27 8.21 8.21 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74 11.64 11.64 0 0 1-8.45-4.29 4.16 4.16 0 0 0-.55 2.07 4.09 4.09 0 0 0 1.82 3.41 4.05 4.05 0 0 1-1.86-.51v.05a4.1 4.1 0 0 0 3.3 4 3.933 3.933 0 0 1-1.1.17 4.907 4.907 0 0 1-.77-.07 4.11 4.11 0 0 0 3.83 2.84A8.22 8.22 0 0 1 2 18.28a11.57 11.57 0 0 0 6.29 1.85A11.589 11.589 0 0 0 20 8.45v-.53a8.43 8.43 0 0 0 2-2.12" })
  }
), Q = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: [
      /* @__PURE__ */ a("path", { d: "M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6" }),
      /* @__PURE__ */ a(
        "path",
        {
          fillRule: "evenodd",
          d: "M18.487 19.611A9.978 9.978 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.978 9.978 0 0 0 3.513 7.611A9.96 9.96 0 0 0 12 22c2.475 0 4.74-.9 6.487-2.389m-.657-2.267A7.592 7.592 0 0 0 20 12a8 8 0 1 0-13.875 5.43C7.168 15.402 9.406 14 12 14c2.557 0 4.769 1.363 5.83 3.344",
          clipRule: "evenodd"
        }
      )
    ]
  }
), X = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 2a10 10 0 0 0-7.35 16.76 10.001 10.001 0 0 0 14.7 0A9.999 9.999 0 0 0 12 2m0 18a8 8 0 0 1-5.55-2.25 6 6 0 0 1 11.1 0A8 8 0 0 1 12 20m-2-10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8.91 6A8 8 0 0 0 15 12.62a4 4 0 1 0-6 0A8 8 0 0 0 5.09 16 7.92 7.92 0 0 1 4 12a8 8 0 1 1 16 0 7.92 7.92 0 0 1-1.09 4" })
  }
), Y = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12.3 12.22A4.92 4.92 0 0 0 14 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 1 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M9 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6m9.74.32A5 5 0 0 0 15 3.5a1 1 0 1 0 0 2 3 3 0 0 1 3 3 3 3 0 0 1-1.5 2.59 1 1 0 0 0-.05 1.7l.39.26.13.07a7 7 0 0 1 4 6.38 1 1 0 0 0 2 0 9 9 0 0 0-4.23-7.68" })
  }
), Z = (h) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ a("path", { d: "M12 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m7.5 14h-1v-5a1 1 0 0 0-1-1h-5v-2h5a1 1 0 0 0 0-2h-5v-2a1 1 0 0 0-2 0v7a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2m-6.8-1.6a4 4 0 0 1-7.2-2.4 4 4 0 0 1 2.4-3.66A1.003 1.003 0 0 0 7.1 11a5.999 5.999 0 1 0 7.2 9.1 1 1 0 0 0-1.6-1.2" })
  }
);
export {
  t as AlertIcon,
  n as AnimalIcon,
  c as ApproveCircleIcon,
  r as ApproveIcon,
  v as ArrowLeftIcon,
  w as ArrowRightIcon,
  i as BabyIcon,
  e as BarsIcon,
  s as BuildingIcon,
  g as CalendarIcon,
  d as CallIcon,
  m as CanoeIcon,
  p as ChatInfoIcon,
  x as ChevronDownIcon,
  I as ChevronLeftIcon,
  M as ChevronRightIcon,
  C as CloseIcon,
  u as CreditCardIcon,
  A as EditIcon,
  f as ExternalLinkIcon,
  V as EyeIcon,
  S as FacebookIcon,
  B as FaqIcon,
  z as ForkIcon,
  H as GridIcon,
  L as InfoIcon,
  P as InstagramIcon,
  R as LocationIcon,
  k as LogoutIcon,
  U as MapIcon,
  b as MinusIcon,
  E as NoPreviewIcon,
  F as PhoneIcon,
  T as PictureIcon,
  y as PingPongIcon,
  j as PlusIcon,
  q as SettingIcon,
  D as ShopIcon,
  G as StarIcon,
  N as SunUmbrellaIcon,
  W as SupportIcon,
  J as TicketIcon,
  K as TimeClock,
  O as TwitterIcon,
  Q as UserIcon,
  X as UserProfileIcon,
  Y as UsersIcon,
  Z as WheelChairIcon
};
